export default __webpack_public_path__ + "static/emprego_concello-750c0b9b31780b51ea785d1209483d46.png";